import React, {useEffect, useRef, useState} from 'react';
import Menu from "../resources/icon/menu-dark.png"
import Close from "../resources/icon/close-dark.png"
import UserMenu from "../components/menus/UserMenu";
import Loading from "../components/Utils/Loading";
import ErrorPage from "../components/Utils/ErrorPage";
import {MobileMenu} from "../components/menus/MobileMenu";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import ApiProgress from "../components/progressBar/ApiProgress";
import PlatformLogo from "./PlatformLogo";
import PageTabs from "../components/pageTabs/PageTabs";
import PageBreadcrumb from "../components/pageTabs/PageBreadcrumb";

function LayoutHeader({menus, totalMenu, clicked, setClicked}) {
    const userMenuRef = useRef(null);
    const api = useSelector((state) => state.api);
    const user = useSelector((state) => state.auth.user);
    const [openMenu, setOpenMenu] =useState(false);
    const toggleMenu =()=>{
        setOpenMenu(!openMenu)
    }

    useEffect(() => {

        //외부 클릭시 userMenu 닫음
        function handleClickOutside(event) {
            // 해당부분이 toggle버튼과 같이돌아서 mobile-menu 아이콘은 제외
            if (userMenuRef.current && !userMenuRef.current.contains(event.target) && !event.target.closest('.mobile-menu')) {
                setOpenMenu(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [userMenuRef]);

    const navigate = useNavigate();
    return (
        <div className="nav-header">

            {api.apiLoading &&
              // {true &&
                <Loading background full/>
            }

            <div className={"flex nav-header-1"}>
                <PlatformLogo variant="menu" className="nav-header-mobile-logo h-[26px] w-auto md:hidden" />
                <button>
                    {openMenu ?
                        <img src={Close} className="mobile-menu" onClick={() => toggleMenu()}/>
                     :
                        <img src={Menu} className="mobile-menu" onClick={() => toggleMenu()}/>
                    }
                </button>
                <PageBreadcrumb className="nav-header-breadcrumb" />
                <UserMenu user={user} />
                <div className={`mobile-menu-view-background ${openMenu ? 'show' : 'none'}`} onClick={()=>setOpenMenu(false)}></div>
                <div ref={userMenuRef} className={`mobile-menu-view ${openMenu ? 'slide-in' : ''}`} >
                    <MobileMenu data={totalMenu}  setOpenMenu={setOpenMenu} setClicked={setClicked} />
                </div>
            </div>

            {api.progressOn &&
            // {1===1 &&
                <ApiProgress />
            }



        {api.error &&
            <ErrorPage status={api.apiMessage.code}/>
        }

            <div className="nav-header-2">
                <PageTabs />
            </div>
        </div>
    );
}

export default LayoutHeader;
